import React from "react";
import {
	BooleanInput,
	Datagrid,
	DateField,
	EditButton,
	Filter,
	List,
	TextField,
	TextInput,
	ShowButton,
} from "react-admin";

import { CustomDeleteButtonWithCustomConfirm } from "../../customComponents/CustomButtons";
import { userPreferences } from "../../utils/fakeUserPrefrences";
import { constants } from "../../utils/constants";
import { CustomBooleanInput } from "../../customComponents/CustomBooleanInput";

const PeerSupportGroupFilter = (props) => (
	<Filter {...props}>
		<TextInput source="search" alwaysOn />
		<BooleanInput source="isActive" defaultValue={true} />
	</Filter>
);

export const PeerSupportGroupList = (props) => {
	return (
		<List
			{...props}
			perPage={constants.perPage}
			bulkActionButtons={false}
			filters={<PeerSupportGroupFilter />}
			exporter={false}
		>
			<Datagrid>
				<TextField
					source={`title.${userPreferences.defaultTranslationLanguage}`}
					sortable={false}
				/>
				<DateField
					source="sessionDatetime"
					sortable={false}
					showTime
				/>
				<CustomBooleanInput source="isActive" sortable={false} />
				<ShowButton />
				<EditButton />
				<CustomDeleteButtonWithCustomConfirm mutationMode="pessimistic" />
			</Datagrid>
		</List>
	);
};

export default PeerSupportGroupList;
